export const PURGE_AUTH = 'logOut';
export const SET_AUTH = 'setUser';
export const SET_AUTH_ME = 'setUserMe';
export const SET_ALL = 'setAll';
